import Vue from 'vue';
import Vuex from 'vuex';
import permissoes from './modules/permissoes';
import formCotacao from './modules/formCotacao';
import formEndosso from './modules/formEndosso';
import formCorretorReserva from './modules/formCorretorReserva';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loadingPage: false,
  },
  mutations: {
    startLoading() {
      this.state.loadingPage = true
    },
    endLoading() {
      this.state.loadingPage = false;
    },
  },
  modules: {
    permissoes,
    formCotacao,
    formEndosso,
    formCorretorReserva
  }
});


export default store;



// WEBPACK FOOTER //
// ./src/store/index.js